import { useEffect } from "react";

import Button from "../../../components/UI/Button";

const SummaryPopup = ({ trigger, setTrigger }) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        trigger &&
        !event.target.closest(`.app-ai-quote-summary-popup-inner`)
      ) {
        setTrigger(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [trigger, setTrigger]);

  const handleClose = () => {
    setTrigger(!trigger);
  };

  return trigger ? (
    <div className="app-ai-quote-summary-popup">
      <div className="app-ai-quote-summary-popup-inner">
        <button
          onClick={handleClose}
          className="app-ai-quote-summary-popup-close-btn"
        >
          <img
            src="/order-now/icons/icon-cross.svg"
            width={24}
            height={24}
            alt="Close icon"
          />
        </button>
        <div className="app-ai-quote-summary-popup-content">
          <img
            src={`/order-now/icons/icon-success.svg`}
            width={96}
            height={96}
            alt="Success icon"
          />
          <h3>Thank you for your request!</h3>
          <p>
            Our project manager will check everything and we will get back to you with a final estimate and the timeline within 24 hours.
            If you have any questions, please contact us via email
            <br />
            <br />
            <a href="mailto:support@getdevdone.com">support@getdevdone.com</a>
          </p>
          <Button onClick={handleClose}>Okay, got it</Button>
        </div>
      </div>
    </div>
  ) : null;
};

export default SummaryPopup;
